module.exports = __webpack_public_path__ + "static/img/1_6_3.8976918f.jpg";